// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import Widget from 'app/components/Widget';
import styles from './WidgetLastComments.styles';
import api from 'utils/API';
import {truncate} from 'utils/Helper';

class WidgetLastComments extends React.Component<Props> {
    unmounted = false;

    constructor(props) {
      super(props);

      this.state = {
        list: []
      };
    }

    componentDidMount() {
      api.post('/comments/last')
      .then(response => {
        if (this.unmounted) {
          return;
        }
        
        const list = response.data.list || [];
        this.setState({list});
      });
    }

    componentWillUnmount() {
      this.unmounted = true;
    }

    render() {
      const {classes} = this.props;
      return (
        <Widget title='آخرین دیدگاه‌ها' padding={false}>
          <ul className={classes.list}>
            {this.state.list.map(item => {
              return (
                <li key={item.id} className={classes.item}>
                  <article>
                    <header className={classes.header}>
                      <Link
                        to={`/${item.post.name}?goto=comment-${item.id}`}
                        rel="nofollow"
                        className={classes.author}
                      >
                        {item.author.name}
                      </Link>
                      <span> در </span>
                      <Link
                        to={`${item.post.name}?goto=comment-${item.id}`}
                        title={item.post.title}
                        rel="nofollow"
                        className={classes.postTitle}
                      >
                       «{truncate(item.post.title, 30)}»
                      </Link>
                      <span> گفت: </span>
                    </header>
                    <div className={classes.comment}>
                      {truncate(item.content, 140)}
                    </div>
                  </article>
                </li>
              );
            })}
          </ul>
        </Widget>
      );
    }
}

const Component = withStyles(styles)(WidgetLastComments);
export {Component as WidgetLastComments};
export default Component;